import { useMemo } from "react";
import { siteDisplayNameFromLoadedConfig } from "./publicSiteConfigLoader";
import { usePublicSiteConfigContext } from "@Front/Services/PublicSiteConfig/usePublicUiOptions";

export type PublicSiteDisplayNameState = {
	ready: boolean;
	siteDisplayName: string | null;
};

/**
 * Libellé verticale (`sites.label` via `display_name`) depuis {@link PublicSiteConfigProvider}.
 */
export function usePublicSiteDisplayName(): PublicSiteDisplayNameState {
	const { config } = usePublicSiteConfigContext();

	return useMemo(
		() => ({
			ready: config !== null,
			siteDisplayName: config ? siteDisplayNameFromLoadedConfig(config) : null,
		}),
		[config],
	);
}
